import * as React from 'react';
import Link from 'next/link';
import { cn } from '@/lib/shared/ui';

export const MailToSupport = ({ className }: { className?: string }) => (
  <Link target="_blank" href="mailto:support@figure53.com" className={cn('underline', className)}>
    support@figure53.com
  </Link>
);
